import { TuneOutlined } from '@mui/icons-material';
import { Box, Button, Chip, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import Sheet from '../../common/components/Sheet';
import GeoLocationFilter from '../filters/GeoLocationFilter';
import BrandsFilter from '../filters/BrandsFilter';

export default function SearchBuyerCounts(): React.JSX.Element {
  const { t } = useTranslation(['common', 'search']);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <Chip
        variant="filter"
        icon={<TuneOutlined />}
        label={t('common:filters')}
        onClick={() => setDrawerOpen(true)}
      />
      <Sheet
        open={drawerOpen}
        keepMounted
        width={400}
        onClose={() => setDrawerOpen(false)}
        title={t('common:filters')}
      >
        <Box
          sx={{
            height: '100%',
            mt: 1.5,
            overflow: 'auto',
          }}
        >
          <GeoLocationFilter mode="ACCORDION" index={import.meta.env.REACT_APP_ALGOLIA_COMPANY_INDEX} unmountOnExit={false} />
          <Divider />
          <BrandsFilter />
        </Box>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 2,
            mb: 1,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => setDrawerOpen(false)}
          >
            {t('search:validate_changes')}
          </Button>
        </Box>
      </Sheet>
    </>
  );
}
